import Http from '@services/httpClient';
import Promise from 'bluebird';
import _ from 'lodash';

const prefix = '/api/v1/order';

export default {
  getDefaultPackage() {
    return new Promise((resolve, reject) => {
      Http.get({
        url: `${prefix}/packages/default`,
      })
        .then((res) => resolve(res.data))
        .catch((e) => reject(e));
    });
  },

  getDefaultActivePromo() {
    return new Promise((resolve, reject) => {
      Http.get({
        url: `${prefix}/promos/default`,
      })
        .then((res) => resolve(res.data))
        .catch((e) => reject(e));
    });
  },

  calculateOrder(id: string | number, code: string) {
    return new Promise((resolve, reject) => {
      Http.post({
        url: `${prefix}/calculate`,
        data: {
          packageId: id,
          code,
        },
      })
        .then((res) => resolve(res.data))
        .catch((e) => reject(e));
    });
  },

  placeOrder(payload: any) {
    return new Promise((resolve, reject) => {
      Http.post({
        url: `${prefix}/place`,
        data: {
          promoCode: _.get(payload, 'coupon'),
          paymentCode: _.get(payload, 'paymentMethod'),
          packageId: _.get(payload, 'packageId'),
          email: _.get(payload, 'email'),
        },
      })
        .then((res) => resolve(res.data))
        .catch((e) => reject(e));
    });
  },
};
